import { IInboxMessage, IOutboxBroadcastMessage, IOutboxMessage } from "services/widget";
import { ActionsUnion, createAction } from "store/helper";

export enum WidgetIntegrationActionNames {
  WIDGET_INBOX_MESSAGE = "WIDGET_INBOX_MESSAGE",
  WIDGET_OUTBOX_MESSAGE = "WIDGET_OUTBOX_MESSAGE",
  WIDGET_OUTBOX_BROADCAST_MESSAGE = "WIDGET_OUTBOX_BROADCAST_MESSAGE",
}

export const WidgetIntegrationActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  receiveInboxMessage: (message: IInboxMessage, connectionId: string) =>
    createAction(WidgetIntegrationActionNames.WIDGET_INBOX_MESSAGE, { message, connectionId }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendOutboxMessage: (message: IOutboxMessage) =>
    createAction(WidgetIntegrationActionNames.WIDGET_OUTBOX_MESSAGE, { message }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  sendBroadcastMessage: (message: IOutboxBroadcastMessage) =>
    createAction(WidgetIntegrationActionNames.WIDGET_OUTBOX_BROADCAST_MESSAGE, { message }),
};

export type WidgetIntegrationAction = ActionsUnion<typeof WidgetIntegrationActions>;
